import { Component, Injector } from '@angular/core';
import { CustomInjector, RouterHelperService } from '@evorait/pace-core';

@Component({
    selector: 'pace-fi-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false,
})
export class AppComponent {
    public title = 'pace-forms-for-factory-installation';
    public constructor(
        private readonly injector: Injector,
        private readonly routerHelper: RouterHelperService,
    ) {
        // Make injector statically available for access in domain models, where angular does not provide a DI mechanism
        CustomInjector.setInjector(this.injector);
        this.routerHelper.subscribeToEvents();
    }
}
